{
  "id": 43,
  "location": "paris",
  "difficulty": "hard",
  "moves": 24,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "cupcake", "count": 44 }
  ],
  "stars": [4920, 6320],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . X . . X . .",
    ". . X . . X . .",
    ". . x . . x . .",
    ". . x . . x . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.494, "movesLeft": 3.9, "closeLosses": 0.116, "target": 0.5 }
}
